import { createGlobalStyle, css } from 'styled-components';

import { DRAWER_HEIGHT_CSS_VAR, MODAL_HEIGHT_CSS_VAR } from '../constants/cssVariables';
export interface DrawerGlobalStylesProps {
  closeTimeoutMS: number;
  contentClassNames: ReactModal.Classes;
  overlayClassNames: ReactModal.Classes;
}

const PARTIAL_PANEL_SIZE_PERCENT = 60;

export const DrawerGlobalStyles = ({
  closeTimeoutMS,
  contentClassNames,
  overlayClassNames,
}: DrawerGlobalStylesProps) => createGlobalStyle`
  .${overlayClassNames.base} {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 200;
    transition: opacity ${closeTimeoutMS}ms ease 0s;
    opacity: 0;

    &::before {
      background: var(--neutral-black-base);
      opacity: 0.4;
      content: '';
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .${overlayClassNames.afterOpen} {
    opacity: 1;
  }

  .${overlayClassNames.beforeClose} {
    opacity: 0;
  }

  .${contentClassNames.base} {
    bottom:0;
    box-sizing: border-box;
    height: 100vh;
    height: var(${DRAWER_HEIGHT_CSS_VAR});
    min-height: 100%;
    position: absolute;
    transition: transform ${closeTimeoutMS}ms ease ${closeTimeoutMS}ms;
    width: 100%;

    &[data-transition-from='right'] {
      right: 0;
      transform: translateX(100vw);
    }
    &[data-transition-from='left'] {
      left: 0;
      transform: translateX(-100vw);
    }
    &[data-transition-from='bottom'] {
      transform: translateY(100vh);
    }

    &[data-panel-size='partial'] {
      width: ${PARTIAL_PANEL_SIZE_PERCENT}%;
      
      &[data-transition-from='right'] {
        transform: translateX(${PARTIAL_PANEL_SIZE_PERCENT}vw);
      }
      &[data-transition-from='left'] {
        transform: translateX(-${PARTIAL_PANEL_SIZE_PERCENT}vw);
      }
    }
  }

  .${contentClassNames.afterOpen} {
    transform: translateX(0) !important;

    &[data-transition-from='bottom'] {
       transform: translateY(0) !important;
    }
  }

  .${contentClassNames.beforeClose} {
    transition-delay: 0s;

    &[data-transition-from='bottom'] {
      transform: translateY(100vh) !important;
    }
    &[data-transition-from='right'] {
      transform: translateX(100vw) !important;
    }
    &[data-transition-from='left'] {
      transform: translateX(-100vw) !important;
    }
  }
`;

export const drawerContent = css`
  position: fixed;
  height: 100vh;
  height: var(${DRAWER_HEIGHT_CSS_VAR});
  min-height: 100%;
  top: 0;
  right: 0;
  width: 100%;
`;

export const modalOverlay = css`
  position: fixed;
  height: 100vh;
  height: var(${MODAL_HEIGHT_CSS_VAR});
  width: 100vw;
  top: 0;
  right: 0;
`;
